<div class="layout-topbar">
    <div class="py-2">
        <p-image class="flex pl-2" src="https://tiravto.com/assets/logo-small.png" width="150" height="60"></p-image>
    </div>


    <!--<div class="layout-topbar-logo-container">
        &lt;!&ndash;<button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>&ndash;&gt;
&lt;!&ndash;        <a class="layout-topbar-logo !bg-black" routerLink="/">
            <img src=" class="h-15 w-40"/>
        </a>&ndash;&gt;
    </div>-->

    <div class="layout-topbar-actions ">
        <div class="layout-config-menu">
            <!--<button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                <i [ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
            </button>-->
            <div class="relative hidden">
                <button
                    class="layout-topbar-action layout-topbar-action-highlight"
                    pStyleClass="@next"
                    enterFromClass="hidden"
                    enterActiveClass="animate-scalein"
                    leaveToClass="hidden"
                    leaveActiveClass="animate-fadeout"
                    [hideOnOutsideClick]="true"
                >
                    <i class="pi pi-palette"></i>
                </button>
                <app-configurator />
            </div>
        </div>

        <!--<button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
            <i class="pi pi-ellipsis-v"></i>
        </button>-->

        <!--<div class="layout-topbar-menu hidden lg:block">
            <div class="layout-topbar-menu-content">
                <button type="button" class="layout-topbar-action">
                    <i class="pi pi-user"></i>
                    <span>Profile</span>
                </button>
            </div>
        </div>-->
    </div>
</div>
